import { useContext } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "../../Components/Select";
import TextInput from "../../Components/TextInput";
//import TextInput from "../Components/TextInput";
import "./KarayoluTasinmazBilgileri.css";
import TextArea from "../../Components/TextArea";
import { Link } from "react-router-dom";

export default function KarayoluTasinmazBilgileri() {
  const {
    araziYapilari,
    toprakBunyeYapilari,
    tasinmazEgimi,
    setTasinmazEgimi,
sulamaAciklama, setSulamaAciklama,

    setAraziYapisi,
    toprakBunyesi,
    settoprakBunyesi,
    koyeUzaklik,
    setKoyeUzaklik,
    ilceUzaklik,
    setIlceUzaklik,
    kesifAnlatim,
    setKesifAnlatim,
    kesifTarihi,

    setKesifTarihi,
    araziYapisi,
    setKapitalizasyonFaizOrani,
  } = useContext(GlobalContext);

  const kapitalizasyonAyarla = () => {
    araziYapisi && araziYapisi === "Sulu"
      ? setKapitalizasyonFaizOrani(0.04)
      : setKapitalizasyonFaizOrani(0.05);
  };

  // useEffect(() => {
  //   setKesifTarihi("2024-04-25");
  // }, []);

  return (
    <>
      <GlobalProvider>
        <div className="container">
          <div className="row text-center my-3">
            <h1>Yapılan Keşfe İlişkin Bilgiler</h1>
          </div>

          <div className="row">
            <div className="col-lg-">
              <label htmlFor="araziYapisi">Arazi Yapısı</label>
              <Select
                Change={setAraziYapisi}
                name="araziYapisi"
                liste={araziYapilari}
                mesaj="Arazi Yapısı Seçiniz"
                value={araziYapisi}
              />
              <label htmlFor="toprakYapisi">Toprak Yapısı</label>
              <Select
                Change={settoprakBunyesi}
                name="toprakYapisi"
                liste={toprakBunyeYapilari}
                mesaj="Toprak Bünye Sınıfını Seçiniz"
                value={toprakBunyesi}
              />
              <label htmlFor="egim">Taşınmaz Eğimi</label>
              <TextInput
                type="text"
                name="egim"
                detail="Taşınmaz Eğimi %"
                Change={setTasinmazEgimi}
                value={tasinmazEgimi}
              />
            </div>

            <div className="col-lg-4">
              <TextInput
                name="kesifTarihi"
                type="date"
                detail="Keşif Tarihi"
                Change={setKesifTarihi}
                value={kesifTarihi}
              />
              <TextInput
                type="text"
                name="koyeuzaklik"
                detail="Köy/Mah. Uzaklık(m)"
                Change={setKoyeUzaklik}
                value={koyeUzaklik}
              />
              <TextInput
                type="text"
                name="ilceyeuzaklik"
                detail="İlçe Merk. Uzaklık(m)"
                Change={setIlceUzaklik}
                value={ilceUzaklik}
              />
              {araziYapisi === "Sulu" ? (
                <TextArea
                  name="sulamaAciklama"
                  Change={setSulamaAciklama}
                  rows="5"
                  detail="Taşınmazın Su Kaynağı ve Sulama Yöntemi"
                  value={sulamaAciklama}
                ></TextArea>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-4">
              <TextArea
                name="kesifAnlatim"
                Change={setKesifAnlatim}
                rows="5"
                detail="Varsa Keşfe İlişkin Ekstra Anlatımlar"
                value={kesifAnlatim}
              ></TextArea>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <Link to="/kytasinmazbilgileri">
                <button className="btn btn-success btn-lg mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>{" "}
                  Taşınmaz Bilgileri
                </button>
              </Link>
            </div>
            <div className="col-3"></div>
            <div className="col-3"></div>
            <div className="col-3">
              <Link to="/kydosyaincelemesi">
                <button
                  onClick={() => kapitalizasyonAyarla()}
                  className="btn btn-primary btn-lg mt-5"
                >
                  Dosyadaki Belgelere Git{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </GlobalProvider>
    </>
  );
}
